import AwaitBlock from './AwaitBlock';
import Comment from './Comment';
import Component from './Component';
import EachBlock from './EachBlock';
import Element from './Element';
import Head from './Head';
import IfBlock from './IfBlock';
import MustacheTag from './MustacheTag';
import RawMustacheTag from './RawMustacheTag';
import Slot from './Slot';
import Text from './Text';
import Title from './Title';
import Window from './Window';

export default {
	AwaitBlock,
	Comment,
	Component,
	EachBlock,
	Element,
	Head,
	IfBlock,
	MustacheTag,
	RawMustacheTag,
	Slot,
	Text,
	Title,
	Window
};
